<template>
  <div class="single-blog-post">
    <div v-if="loading" style="height: 800px">
      <spinner></spinner>
    </div>
    <article v-if="post" class="blog-post">
      <header class="blog-post__header">
        <h1>{{ post.title }}</h1>
        <div v-if="post.tags_static" class="category">
          <i class="iconmoon-tag"></i>{{ post.tags_static }}
        </div>
        <div class="separator"></div>
        <ul>
          <li v-if="post.Author">
            By <span class="color--red">{{ post.Author.name }}</span>
          </li>
          <li>
            <time>{{ formattedTime(post.published_at) }}</time>
          </li>
        </ul>
        <div
          v-if="post.intro_text"
          class="introduction"
          v-html="post.intro_text"
        ></div>
      </header>
      <div
        v-if="post.header_type === 'video'"
        class="blog-post-picture clearfix"
      >
        <div class="embed-responsive embed-responsive-16by9 video">
          <iframe
            class="embed-responsive-item"
            :src="getVideoLink(post.header_video.video_url)"
            frameborder="0"
            allowfullscreen=""
          ></iframe>
        </div>
      </div>
      <div
        v-else-if="post.header_type === 'image'"
        class="blog-post-picture clearfix"
      >
        <bi-picture
          v-if="post.header_type === 'image' && post.header_image"
          :is-legacy="post.header_image.isLegacy"
          :thumb-formats="post.header_image.formats"
          :code="post.header_image.code"
          :thumb-sizes="post.header_image.sizes"
        ></bi-picture>
        <span
          class="blog-post-picture__caption blog-post-picture__caption--right"
          >© Screenshot from Mini DAYZ [Photos Credit: Bohemia Interactive
          a.s.]</span
        >
      </div>
      <div v-if="post.content" id="contents" class="blog-post__content">
        <v-runtime-template :template="getTemplate(post.content)" />
        <blog-post-author v-if="post.Author" :author="post.Author" />
      </div>
      <post-footer :post="post"></post-footer>
    </article>
  </div>
</template>

<script>
import PostFooter from "../partials/Blog/PostFooter.vue";
import BlogPostAuthor from "../partials/Blog/BlogPostAuthor";
import Spinner from "../partials/Spinner.vue";
import AppGallery from "../dynamic-components/AppGallery";
import AppGallerySlide from "../dynamic-components/AppGallerySlide";
import AppCollapse from "../dynamic-components/AppCollapse";
import AppCollapseItem from "../dynamic-components/AppCollapseItem";
import AppPicture from "../dynamic-components/AppPicture";
import AppYoutube from "../dynamic-components/AppYoutube";
import VRuntimeTemplate from "v-runtime-template";
import BiPicture from "../partials/BiPicture";
import { getPost } from "../../services/posts";
import { parseDate } from "../../helpers/utils";
import urlParser from "js-video-url-parser";

export default {
  components: {
    "post-footer": PostFooter,
    spinner: Spinner,
    "bi-picture": BiPicture,
    "blog-post-author": BlogPostAuthor,
    AppGallerySlide,
    AppGallery,
    AppPicture,
    AppYoutube,
    AppCollapse,
    AppCollapseItem,
    "v-runtime-template": VRuntimeTemplate
  },
  data() {
    return {
      post: null,
      loading: true
    };
  },
  computed: {
    slug() {
      if (this.$route.params) {
        return this.$route.params.slug;
      } else {
        return "";
      }
    }
  },
  watch: {
    $route(to, from) {
      this.slug = to.params.slug;
    }
  },
  created() {
    this.fetch();
  },
  metaInfo() {
    return {
      title: this.post && this.post.title,
      meta: [
        {
          vmid: "og:image",
          property: "og:image",
          content: this.post && this.post.preview_image
        },
        {
          vmid: "description",
          name: "description",
          content: this.post && this.post.intro_text_stripped
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.post && this.post.intro_text_stripped
        },
        { vmid: "og:type", property: "og:type", content: "article" }
      ]
    };
  },
  methods: {
    getTemplate(articleContent) {
      return `<div class="article-content-body">${articleContent}</div>`;
    },
    formattedTime(time) {
      let date = new Date(time);
      return parseDate(date);
    },
    async fetch() {
      let request = await getPost(this.slug);
      this.post = request.data;
      this.loading = false;
    },
    getVideoLink(link) {
      let videoInfo = urlParser.parse(link);
      return urlParser.create({ videoInfo: videoInfo, format: "embed" });
    }
  }
};
</script>
